<template>
    <Link class="btn btn-warning">{{ $t('button.preview') }}</Link>
</template>

<script setup lang="ts">
import {Link} from "@inertiajs/vue3";
</script>

<style scoped>

</style>
